import React from "react";

// Shared currency + language state for the iframe widget. Lets the dropdowns switch
// without window.location.reload() (which resets document.referrer and breaks the
// Parent-Domain domain check). Value is built in app/Routes.js.
const IframeSettingsContext = React.createContext(null);

export function useIframeSettings() {
    return React.useContext(IframeSettingsContext) || {};
}

export default IframeSettingsContext;
